import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LoadingMaskService } from '../../../shared/loading-mask/loading-mask.service';
import { Guide, GuidesService } from './guides.service';

@Injectable()
export class GuidesResolve implements Resolve<Guide[]> {
	constructor(private service: GuidesService,
	            private mask: LoadingMaskService) {
	}

	resolve(route: ActivatedRouteSnapshot): Observable<Guide[]> {
		this.mask.addLoading();
		return this.service.getGuides()
			.map((guides: Guide[]) => {
				this.mask.removeLoading();
				return guides ? guides : [];
			});
	}
}
